import type { DiagnosisData } from "../types";

/**
 * Empty DiagnosisData stub for quick-search mode (PED-12650).
 *
 * Quick search skips the DiagnosisStep entirely, but LocationStep's manual
 * search is gated on a truthy `diagnosis` (handleSearch early-returns without
 * one). The stub satisfies that gate while carrying no deal data: no city or
 * coordinates, so LocationStep's mount auto-search never fires, and the empty
 * dealId keeps every analytics `deal_id` resolving to null.
 */
export function buildQuickSearchDiagnosis(): DiagnosisData {
  return {
    dealId: "",
    companyName: "",
    contactName: "",
    contactEmail: "",
    segment: "",
    targetCity: "",
    positionsMin: "",
    positionsMax: "",
    monthlyBudget: "",
    needs: "",
  };
}
